import blockOverflow from './modules/block-overflow';
import { getFloors, getRanges } from './modules/block-find';
import './modules/block-range';
import './modules/block-floors';

/* global searchConfig */
/* eslint no-undef: "error" */

document.addEventListener('DOMContentLoaded', blockOverflow);
window.addEventListener('resize', blockOverflow);

const searchBtn = document.getElementById('search');
const rangeMin = 'js-range-min';
const rangeMax = 'js-range-max';

const params = {
	area: { min: rangeMin, max: rangeMax },
	rooms: { min: rangeMin, max: rangeMax },
};

const search = () => {
	searchBtn.onclick = (e) => {
		e.preventDefault();

		const find = new URL(`${searchConfig.url}#anchor`);

		const ranges = getRanges(params);
		Object.entries(ranges).forEach(([k, v]) => {
			find.searchParams.append(`${k}_min`, v.min);
			find.searchParams.append(`${k}_max`, v.max);
		});

		const floor = getFloors('[data-floor-number]');
		find.searchParams.append('floor', JSON.stringify(floor));
		find.searchParams.append('search', true);

		window.location.href = find.href;
	};
};

document.addEventListener('DOMContentLoaded', search);
